module.exports = __webpack_public_path__ + "img/passport.ddae614c.png";